import { render, staticRenderFns } from "./CreateMode.vue?vue&type=template&id=d4775f24&scoped=true&lang=pug&"
import script from "./CreateMode.vue?vue&type=script&lang=ts&"
export * from "./CreateMode.vue?vue&type=script&lang=ts&"
import style0 from "./CreateMode.vue?vue&type=style&index=0&id=d4775f24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4775f24",
  null
  
)

export default component.exports